 
import { Dropdown, DropdownMenuItemType, FontIcon, IDropdownOption, IDropdownProps, IRenderFunction, SearchBox, Spinner, SpinnerSize } from "@fluentui/react";
import React from "react";   

export const filterSearchableDropdownOptions = (
  options: IDropdownOption[],
  searchText: string
): IDropdownOption[] =>
  options.map((option) =>
    option.disabled || option.text.toLowerCase().includes(searchText.toLowerCase())
      ? option
      : { ...option, hidden: true }
  );

export const renderAsyncDropdownItem: IRenderFunction<IDropdownOption> = (option, defaultRender) => {
  const asyncState = option?.data?.asyncState;
  if (!asyncState || !option) {
    return defaultRender?.(option) ?? null;
  }

  const isLoading = asyncState === "loading";
  const isError = asyncState === "error";
  return (
    <div
      role="status"
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        minHeight: "36px",
        padding: "0 12px",
        color: isError ? "#a4262c" : "#323130",
        fontWeight: 600
      }}
    >
      {isLoading
        ? <Spinner size={SpinnerSize.small} ariaLabel="Loading options" />
        : <FontIcon iconName={isError ? "ErrorBadge" : "Info"} aria-hidden={true} />}
      <span>{option.text}</span>
    </div>
  );
};

export interface SearchableDropdownProps extends IDropdownProps {
  /**
   * Remote search: called with the text typed in the menu search box. When supplied, options are
   * not filtered locally because the caller already returns server-side matches.
   */
  onSearchTextChange?: (searchText: string) => void;
}

export const SearchableDropdown: React.FunctionComponent<SearchableDropdownProps> = ({ onSearchTextChange, ...props }) => {
    const [searchText, setSearchTextState] = React.useState<string>('');
    const setSearchText = (value: string): void => {
      setSearchTextState(value);
      onSearchTextChange?.(value);
    };
 
    function renderOption(option?: IDropdownOption): JSX.Element {
      if (option?.itemType === DropdownMenuItemType.Header && option.key === "FilterHeader") {
        return <SearchBox id="searchTextId" value={searchText} onChange={(_ev?: React.ChangeEvent<HTMLInputElement>, newValue?: string) => setSearchText(newValue ?? '')} underlined={true} placeholder="Search options"/>;
      }

      return <>{option?.text}</>;
    }

    const onOpenOptionList = () => {
      setTimeout(() => { 
          document.getElementById("searchTextId")?.focus();    
      }, 100);
    } 

   
    return (
       <Dropdown  
        {...props}
        panelProps={{
          onOpen: onOpenOptionList
        }} 
        options={[
          { key: 'FilterHeader', text: '-', itemType: DropdownMenuItemType.Header },
          { key: 'divider_filterHeader', text: '-', itemType: DropdownMenuItemType.Divider },
          ...(onSearchTextChange ? props.options : filterSearchableDropdownOptions(props.options, searchText)),
        ]} 
        onRenderOption={renderOption}
        onRenderItem={renderAsyncDropdownItem}
        onDismiss={() => { setSearchText(''); props.onDismiss?.(); }}
        calloutProps={{
          onLayerMounted: onOpenOptionList,
          calloutWidth: undefined
        }} 
      /> 
    );
  
  };